import React from 'react';
import './StratovaiLoader.css';

const StratovaiLoader = () => {
  return (
    <div className="stratovai-loader-container">
      <div className="stratovai-loader-svg">
        <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="48" cy="48" r="40" stroke="#2563eb" strokeWidth="8" opacity="0.15" />
          <circle
            cx="48"
            cy="48"
            r="40"
            stroke="#2563eb"
            strokeWidth="8"
            strokeDasharray="251.2"
            strokeDashoffset="60"
            strokeLinecap="round"
            className="stratovai-loader-arc"
          />
          <circle
            cx="48"
            cy="20"
            r="6"
            fill="#2563eb"
            className="stratovai-loader-dot"
          />
        </svg>
        <div className="stratovai-loader-text">
          <span className="stratovai-loader-brand">Stratovai</span>
          <span className="stratovai-loader-sub">Intelligent QA Automation</span>
        </div>
      </div>
    </div>
  );
};

export default StratovaiLoader; 